<script>
	import { Router } from "@roxi/routify";
	import { routes } from "../.routify/routes";
    import GlobalCssImports from "./GlobalScssImports.svelte";
</script>
<GlobalCssImports/>
<Router config={{useHash: true}} {routes} />
